/* Tysk katalog for locale-invoice-detail-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'inv.pay.originalAmount': 'Betrag in {currency}',
  'inv.pay.bankAmountCurrency': 'Bankbetrag in {currency}',
  'inv.pay.fxPreview': 'Die Forderung wird mit {receivable} {accountingCurrency} ausgeglichen. Die Differenz zum Bankbetrag wird als {kind} gebucht: {difference}.',
  'inv.pay.fxGain': 'Kursgewinn',
  'inv.pay.fxLoss': 'Kursverlust',
});
